<template>
  <div>
    <back-route-hdr :back-mode="'static'"></back-route-hdr>
    <div class="mar-top bg-white">
      <!-- 会议室相关 -->
      <permit-container :permit-key="permitsMap.roomSubs">
        <calendar-subs :title="` ${cellData.name} `"></calendar-subs>
      </permit-container>
      <div v-show="cellData.pictures.length">
        <van-sticky :offset-top="100">
          <van-tag class="right-tag pull-right" mark type="warning" size="medium"
                   @click="showPics=true">查看{{roomTitle}}图片
          </van-tag>
        </van-sticky>
      </div>

      <van-cell-group class="custom-steps">
        <van-cell>
          <template #default>
            <p class="van-ellipsis list-cell-subject mar-ver-5">{{cellData.name}}</p>
            <p class="line-hgt mar-top-5 mar-btm-0 flex flex-align-center">{{cellData.locationInfo}}</p>
          </template>
        </van-cell>
        <van-cell>
          <template #default>
            <p class="mar-top-0 mar-btm-0 flex flex-align-center">
              <i class="iconfont icon-qunzu text-md mar-rgt-5"></i>
              容纳 {{cellData.capacity}} 人
            </p>
            <p v-show="cellData.roomTypeStr" class="mar-ver-5">
              <i class="iconfont icon-jibie text-md mar-rgt-5"></i>{{cellData.roomTypeStr}}</p>
            <p v-show="cellData.labelStr" class="mar-ver-5">
              <i class="iconfont icon-biaoqian text-md mar-rgt-5"></i>{{cellData.labelStr}}</p>
            <p v-show="cellData.deviceExceptionTip" class="mar-ver-5 text-danger">
              <i class="iconfont icon-xinhao text-md mar-rgt-5"></i>{{cellData.deviceExceptionTip}}</p>
            <p v-show="cellData.moreInfo" class="mar-top-0 mar-btm-0 flex flex-align-center">
              <i class="iconfont icon-gengduo-circle text-md mar-rgt-5"></i>
              {{cellData.moreInfo}}
            </p>
          </template>
        </van-cell>
        <van-cell title="预约情况" title-class="text-sm text-lt">
          <template #title>
            <span>预约情况</span>
            <div class="display-inline-block pad-lft">
              <van-tag round class="mar-rgt-5">不可约</van-tag>
              <van-tag round type="warning" class="mar-rgt-5">已预约</van-tag>
              <van-tag round type="success">可预约</van-tag>
            </div>
          </template>
          <!-- 选取时间为后五天 -->
          <template #label>
            <div class="mar-top" v-for="avInfo in availableData" :key="avInfo.date">
              <div v-show="avInfo.permit.show" class="pull-right mar-top--5">
                <van-button type="primary" block size="mini" @click="clickReserve(avInfo)"
                            :disabled="avInfo.permit.filled">{{avInfo.permit.filled ? '已约满' : '点击预约'}}
                </van-button>
              </div>
              <p class="text-md detail-title">{{avInfo.dateInfo}}
                <span v-show="avInfo.reservedTime.length" class="text-sm text-danger"
                      @click="handleShowMList(avInfo)"><i class="fa fa-th-list"></i> 会议详情</span>
              </p>
              <!-- 渲染可用时段 -->
              <div class="van-steps van-steps--horizontal">
                <div class="van-steps__items">
                  <div v-for="ele in avInfo.stepOptions"
                       :key="avInfo.date + ele.slot" :class="ele.slotClass"
                       class="van-hairline van-step van-step--horizontal">
                    <div class="van-step__title">{{ele.title}}</div>
                    <div class="van-step__circle-container">
                      <i v-show="ele.show" class="van-step__circle"></i></div>
                    <div class="van-step__line"></div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <div class="pad-all">
        <van-button block type="primary" size="small" @click="showCalendar=true">切换日期</van-button>
      </div>

      <van-calendar v-model="showCalendar" color="#2D69E0"
                    :min-date="minDate" :max-date="maxDate"
                    :formatter="formatDate"
                    @confirm="changeDate"></van-calendar>

      <van-popup v-model="showTime" round closeable position="bottom">
        <div class="van-calendar custom-calendar">
          <div class="van-calendar__header">
            <div class="van-calendar__header-title">选择会议时间</div>
            <div class="text-center text-bold mar-btm-10">{{cAvailableInfo.dateInfo}}</div>
          </div>
          <div class="van-calendar__body">
            <div class="van-calendar__month">
              <div class="van-calendar__days">
                <!--<div class="van-calendar__month-mark">T</div>-->
                <div v-for="(slot, idx) in slotOptions" :key="slot.value" class="van-calendar__day"
                     :class="slot.style" @click="clickSlot(slot, idx)">
                  <span>{{slot.label}}</span>
                  <span v-if="slot.activeText" class="van-calendar__bottom-info">{{slot.activeText}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="van-calendar__footer">
            <van-row gutter="10">
              <van-col span="12">
                <van-button class="theme-btn van-calendar__confirm" block @click="submitReserve()">立即预约</van-button>
              </van-col>
              <van-col span="12">
                <van-button class="theme-btn van-calendar__confirm" block @click="submitReserve(true)">填写更多信息
                </van-button>
              </van-col>
            </van-row>
          </div>
        </div>
      </van-popup>

      <van-popup v-model="showMList" round closeable position="bottom" class="pop-min-hgt">
        <div class="van-calendar custom-calendar">
          <div class="van-calendar__header">
            <div class="van-calendar__header-title">{{dateDoc.dateInfo}} 会议列表</div>
          </div>
          <div class="van-calendar__body mar-top-5">
            <div class="van-calendar__month">
              <div class="van-calendar__days">
                <van-cell v-for="(ele, idx) in assembleMList" :key="idx" title=""
                          title-class="list-cell-title pad-btm-10 bord-btm" @click="handleMDetail(ele)">
                  <template #label>
                    <meeting-tags :formatted-mt="ele"></meeting-tags>
                    <p class="list-cell-subject mar-btm-10 mar-top-0">
                      <van-icon v-show="ele.isUserCheckin" class="text-md mar-rgt-5" name="certificate"></van-icon>
                      <van-icon v-show="ele.hasService" class="text-md text-danger mar-rgt-5"
                                name="description"></van-icon>
                      <span :class="ele.showDetail?'text-underline':''">{{ele.subject}}</span>
                      <!--<span v-show="ele.showDetail"> ></span>-->
                    </p>
                    <span>{{ele.meetingTime}}（{{ele.fromNow}}）</span>
                    <span class="pull-right">{{ele.initiatorName || ele.createdBy}} - {{ele.numberOfPeople}}人</span>
                  </template>
                </van-cell>
              </div>
            </div>
          </div>
          <div class="van-calendar__footer pad-btm"></div>
        </div>
      </van-popup>

      <van-image-preview v-model="showPics" :images="cellData.pictures"></van-image-preview>

    </div>
  </div>
</template>

<script>
  import {meetingRoom, meeting} from "../../../../server";
  import {commonConfig, momentFormat} from "../../../../config/common";
  import {
    checkRespCorrect, checkShowPermit,
    formatMListDoc,
    getDateBySlot,
    getReservedSlotsByTime,
    getSlotByDate,
    getTimeBySlot, setSchReserveDate
  } from "../../../../tools/utils";
  import {getStorage, StorageKey} from "../../../../tools/storage";
  import {messageHdl, msgCode} from "../../../../tools/messageHdlr";
  import routerMeta from "../../router/routerMeta";
  import CalendarSubs from "../../components/CalendarSubs"
  import MeetingTags from "../../components/MeetingTags"

  const calendarClass = {
    disable: "van-calendar__day--disabled",
    start: "van-calendar__day--start",
    end: "van-calendar__day--end",
    middle: "van-calendar__day--middle",
  };

  export default {
    components: {
      MeetingTags,
      CalendarSubs
    },
    data() {
      return {
        rid: "",
        roomDoc: {},
        filterDate: moment().startOf('day').toDate(),
        showCalendar: false,
        showTime: false,
        showMList: false,
        checkedSlots: {
          start: "",
          end: "",
        },
        today: moment().format(momentFormat.date),
        cAvailableInfo: {},
        meetingData: [],
        dateDoc: {},
        showPics: false,
      }
    },
    computed: {
      roomTitle() {
        return this.$store.state.formTitles.meetingRoom
      },
      minDate() {
        return new Date(moment(new Date()).subtract(15, "d").endOf('day').valueOf())
      },
      maxDate() {
        return new Date(moment(new Date()).add(90, "d").endOf('day').valueOf())
      },
      mgrResourceUrl() {
        return this.$store.state.sysView.mgrSrcUrl || ""
      },
      // 开始、结束提醒时间相关配置
      sysNoticeInfo() {
        const {disableMeetingNotice, preNoticeTime, endNoticeTime} = this.$store.state.sysConfig;
        return {
          enableNotice: !disableMeetingNotice,
          preNoticeTime,
          endNoticeTime
        }
      },
      // 返回区域相关数据
      locationPicMap() {
        const picMap = {};
        this.$store.state.roomLocations.forEach(lc => {
          if (lc.pictures && lc.pictures.length) {
            picMap[lc.id] = lc.pictures.map(e => this.mgrResourceUrl + e.url)
          }
        });
        return picMap
      },
      // 会议室相关信息
      cellData() {
        let pictures = [];
        const lcPicMap = this.locationPicMap;
        (this.roomDoc.locationList || []).forEach(lc => {
          if (lcPicMap[lc.id]) {
            pictures = pictures.concat(lcPicMap[lc.id])
          }
        });
        const {roomTypes = [], roomLabels = []} = this.$store.state.sysConfig;
        let roomTypeStr = "";
        const {roomTypes: types, labels} = this.roomDoc;
        if (types && types.length) {
          roomTypeStr = roomTypes.filter(e => types.includes(e.value)).map(e => e.label).join('、')
        }
        const labelList = [];
        if (labels && labels.length) {
          roomLabels.forEach(lb => {
            const values = lb.values.filter(e => labels.includes(e.value));
            values.length && labelList.push(values.map(e => e.label).join('、'))
          })
        }
        const moreInfo = [];
        if (this.roomDoc.reviewMode) {
          const mode = commonConfig.reviewModes[this.roomDoc.reviewMode];
          mode && moreInfo.push(`预约需系统${mode.label}`)
        }
        if (this.roomDoc.isServiceSupport) {
          moreInfo.push("支持提供服务")
        }
        if (this.roomDoc.isDisabled) {
          moreInfo.push("不支持预约")
        }
        return {
          ...this.roomDoc,
          roomTypeStr,
          labelStr: labelList.join('、'),
          moreInfo: moreInfo.join('、'),
          locationInfo: (this.roomDoc.locationList || []).map(e => e.name).join('-'),
          // 拼接url返回图片链接
          pictures: pictures.concat((this.roomDoc.pictures || []).map(e => this.mgrResourceUrl + e.url))
        }
      },
      // 后五天会议室使用情况
      availableData() {
        const data = [];
        const {available, moreAvailableData = []} = this.roomDoc;
        available && data.push(available);
        const thisDay = moment().startOf('day');
        return data.concat(moreAvailableData).map(ele => {
          // const eleDate = new Date(ele.date);
          const diffDay = moment(ele.date).diff(thisDay, 'd');
          const selfMinSlot = this.assembleSelfMinSlot(diffDay);
          ele.reservedSlots = getReservedSlotsByTime(ele);
          return {
            ...ele,
            diffDay,
            selfMinSlot,
            dateInfo: moment(ele.date).format(momentFormat.date) + `（周${commonConfig.weekInfo[new Date(ele.date).getDay()]}）`,  // formattedDate
            permit: !this.roomDoc.isDisabled && this.assembleReservePmt(diffDay, selfMinSlot, ele),  // reservePermit
            stepOptions: this.assembleStepOptions(diffDay, selfMinSlot, ele),
          }
        })
      },
      basicStepOptions() {
        const {timelineStartAt, timelineEndAt} = this.$store.state.sysConfig
        const opts = [];
        const {
          min,
          max
        } = timelineStartAt ? this.meetingRoomTime(timelineStartAt, timelineEndAt) : commonConfig.stepSlots;
        let idx = min;
        let timeInterval = (max / 2) - (min / 2)
        // let num = timeInterval >= 20 ? 7 : timeInterval >= 17 ? 6 : 5// 判断时间是不是过长,避免时间过多样式显示不全

        let num = 1;
        if (timeInterval >= 20) {
          num = 8;
        } else if (timeInterval >= 17) {
          num = 6;
        } else if (timeInterval >= 12) {
          num = 5;
        } else if (timeInterval >= 10) {
          num = 4;
        } else if (timeInterval >= 7) {
          num = 3;
        } else if (timeInterval >= 3) {
          num = 2
        }

        while (idx <= max) {
          const show = min === idx || (idx - min) % num === 0 || max === idx && ((idx - min) % num >= 6 && num === 8 || (idx - min) % num >= 4 && num <= 6) || max - min < 7;
          opts.push({
            title: show ? getTimeBySlot(idx) : "",
            show: show,
            slot: idx,
          });
          idx++
        }
        opts.push({
          title: '',
          show: true,
          slot: idx,
        });
        return opts
      },
      basicSlotOptions() {
        const {minSlot, maxSlot} = commonConfig.slotRange;
        const opts = [];
        let idx = minSlot;
        while (idx <= maxSlot) {
          const opt = {
            label: getTimeBySlot(idx),
            value: idx,
            style: "",
            disabled: false,
          };
          opts.push(opt);
          idx++
        }
        opts.push({
          label: '',
          value: idx,
          style: "",
          disabled: true,
        });
        return opts
      },
      // 预约情况节点数据
      slotOptions() {
        const reservedSlots = this.cAvailableInfo.reservedSlots || [];
        const {selfMinSlot} = this.cAvailableInfo;
        // const opts = this.basicSlotOptions;
        const opts = this.basicSlotOptions.filter(ele => ele.value >= 14);
        const disabledInfo = {};
        return opts.map((opt, idx) => {
          const diffParams = {
            style: "",
            disabled: false,
          };
          const slotVal = opt.value;
          if (reservedSlots.includes(slotVal) || slotVal < selfMinSlot) {
            diffParams.style = calendarClass.disable;
            diffParams.disabled = true
          }
          // 开始、结束、期间的样式
          if (slotVal === this.checkedSlots.start) {
            diffParams.style = calendarClass.start;
            diffParams.activeText = "开始"
          } else if (slotVal === this.checkedSlots.end) {
            diffParams.style = calendarClass.end;
            diffParams.activeText = "结束"
          } else if (slotVal > this.checkedSlots.start && slotVal < this.checkedSlots.end) {
            diffParams.style = calendarClass.middle;
          }
          // 存在节点可以作为结束节点，不能作为开始节点
          if (diffParams.disabled && this.checkedSlots.start && !this.checkedSlots.end
            && this.checkedSlots.start < slotVal && !disabledInfo[idx - 1]) {
            let slotIdx = idx - (slotVal - this.checkedSlots.start) + 1;
            let checkPass = true;
            while (slotIdx < idx) {
              if (disabledInfo[slotIdx]) {
                checkPass = false;
                break;
              }
              slotIdx++
            }
            if (checkPass) {
              diffParams.style = "";
              diffParams.allowEnd = true
            }
          }
          // 前一节点不可选时最后一个节点也不可选
          if (idx === opts.length - 1 && !diffParams.disabled && disabledInfo[idx - 1]) {
            diffParams.style = calendarClass.disable;
            diffParams.disabled = true
          }
          disabledInfo[idx] = diffParams.disabled;
          return {...opt, ...diffParams}
        })
      },
      assembleMList() {
        return this.meetingData.map(ele => formatMListDoc(ele, this, this.dateDoc.date))
      },
      showPermits() {
        const permissionList = this.$store.state.permissionList || [];
        return {
          directReserve: checkShowPermit(permissionList, this.permitsMap.directReserve),
        }
      },
    },
    created() {
      const roomFilter = this.$store.state.roomFilter;
      if (roomFilter && roomFilter.date) {
        // console.log(roomFilter.date)
        this.filterDate = moment(roomFilter.date).toDate()
      }
    },
    mounted() {
      this.rid = this.$route.params.rid;
      this.initRoomDoc()
    },
    methods: {
      meetingRoomTime(startTime, endTime) {
        let start = startTime.split(":");
        let end = endTime.split(":");
        let stepSlots = {}
        stepSlots.min = start[1] == '30' ? (Number(start[0]) + 0.5) * 2 : (Number(start[0])) * 2
        stepSlots.max = end[1] == '30' ? (Number(end[0]) + 0.5) * 2 : (Number(end[0])) * 2
        return stepSlots
      },
      initRoomDoc() {
        UILoader.load();
        // 查询房间信息
        meetingRoom.queryList(this, {
          queryFilter: {
            selfCursor: this.rid,
            date: this.filterDate.valueOf(),
            availableDateNum: 4,
          },
          queryAll: true
        }).then(({searchRoom: data = {}}) => {
          UILoader.unload();
          const [edge] = (data.roomEdges || []);
          if (edge && edge.cursor === this.rid && edge.room) {
            this.roomDoc = edge.room;
          } else {
            vtToast(`${this.roomTitle}不存在`)
          }
        }).catch(err => {
          UILoader.unload();
          // console.log(err);
          vtToast(err.message)
        });
      },
      formatDate(day) {
        if (moment(day.date).format(momentFormat.date) === this.today) {
          day.bottomInfo = '今天';
        }
        return day
      },
      // 每改变一次时间需要重新取一次数据
      changeDate(date) {
        this.filterDate = date;
        this.showCalendar = false;
        this.checkedSlots.start = "";
        this.checkedSlots.end = "";
        this.initRoomDoc()
      },
      // 处理节点时间
      assembleSelfMinSlot(diffDay) {
        const {minSlot, maxSlot} = commonConfig.slotRange;
        if (diffDay < 0) return maxSlot;
        if (diffDay > 0) return minSlot;
        return getSlotByDate(new Date())
      },
      // 预约权限相关
      assembleReservePmt(diffDay, selfMinSlot, info) {
        const diffSlotSum = commonConfig.slotRange.maxSlot - selfMinSlot;
        if (diffDay < 0 || diffSlotSum <= 0) return {show: false};
        const reservedSlots = info.reservedSlots.filter(slt => slt >= selfMinSlot);
        return {
          show: true,
          filled: reservedSlots.length >= (diffSlotSum)
        }
      },
      // 时段选择相关处理
      assembleStepOptions(diffDay, selfMinSlot, info) {
        const reservedSlots = info.reservedSlots || [];
        if (!reservedSlots.length && diffDay < 0) return this.basicStepOptions;
        return this.basicStepOptions.map(opt => {
          let slotClass = "";
          if (reservedSlots.includes(opt.slot)) {
            slotClass = 'slot-occupied'
          } else if (!this.roomDoc.isDisabled && opt.slot >= selfMinSlot) {
            slotClass = 'slot-free'
          }
          return {
            ...opt,
            slotClass,
          }
        })
      },
      // 已预约时段会议信息
      handleShowMList(avInfo) {
        // console.log(avInfo);
        if (this.dateDoc.date === avInfo.date) {
          this.showMList = true;
          return
        }
        UILoader.load("加载中...");
        this.dateDoc = avInfo;
        meeting.queryList(this, {
          filterCancel: true,
          queryFilter: {
            date: avInfo.date,
            meetingRoomId: this.rid,
            getIsUserCheckin: true
          }
        }).then(({searchMeeting: data = {}}) => {
          UILoader.unload();
          // console.log(data);
          this.meetingData = (data.meetingEdges || []);
          this.showMList = true;
        }).catch(err => {
          UILoader.unload();
          // console.log(err);
          vtToast(err.message)
        })
      },
      // 可跳转具体的会议详情
      handleMDetail(doc) {
        // doc.showDetail && this.$router.push({
        this.$router.push({
          name: routerMeta.meetingDetailFromRoom.name,
          params: {mid: doc.mid, rid: this.rid}
        })
      },
      clickReserve(avInfo) {
        // console.log(avInfo);
        if (this.showPermits.directReserve) {
          this.cAvailableInfo = avInfo;
          this.checkedSlots.start = "";
          this.checkedSlots.end = "";
          this.showTime = true;
        } else {
          const startTime = setSchReserveDate(avInfo.date, true);
          const destData = {
            // subject: getStorage(StorageKey.username) + "的会议",
            subject: "",
            startTime: startTime.valueOf(),
            endTime: moment(startTime).add(1, 'h').valueOf(),
            meetingRooms: [{...this.roomDoc, roomId: this.rid}],
          };
          this.$store.commit('setReserveInfo', destData);
          this.$router.push({
            name: routerMeta.meetingReserveFromRoom.name,
            params: {rid: this.rid},
          });
        }
      },
      clickSlot(slot, slotIdx) {
        // console.log(slot);
        if (slot.disabled && !slot.allowEnd) return;
        if (this.checkedSlots.start) {
          if (this.checkedSlots.end) {
            this.checkedSlots.start = slot.value;
            this.checkedSlots.end = "";
            return;
          }
          if (this.checkedSlots.start === slot.value) {
            this.checkedSlots.start = "";
            return;
          }
          if (this.checkedSlots.start > slot.value) {
            this.checkedSlots.start = slot.value;
            return;
          }
          const middleSlots = [];
          let sl = this.checkedSlots.start + 1;
          while (sl < slot.value) {
            middleSlots.push(sl);
            sl++
          }
          if (_.intersection(this.cAvailableInfo.reservedSlots || [], middleSlots).length) {
            this.checkedSlots.start = slot.value;
            return;
          }
          this.checkedSlots.end = slot.value;
          return;
        }
        this.checkedSlots.start = slot.value;
      },
      // 提交预约
      submitReserve(more) {
        // console.log('reserve');
        if (!this.checkedSlots.start) {
          vtToast("请选择开始时间！");
          return
        }
        if (!this.checkedSlots.end) {
          vtToast("请选择结束时间！");
          return;
        }
        const destData = {
          subject: more ? "" : getStorage(StorageKey.username) + "的会议",
          startTime: getDateBySlot(this.checkedSlots.start, this.cAvailableInfo.date).valueOf(),
          endTime: getDateBySlot(this.checkedSlots.end, this.cAvailableInfo.date).valueOf(),
          // numberOfPeople: 1,
          deviceRequire: [],  // 仅作为填充参数
          // insideParticipant: [],
          outsideParticipant: [],
        };
        // console.log(destData);
        // 处理会议预约信息
        if (more) {
          // destData.date = moment(destData.date).startOf('day').valueOf();
          destData.meetingRooms = [{
            ...this.roomDoc,
            roomId: this.rid,
          }];
          // destData.insideParticipant = [{
          //   ...getStorage(StorageKey.userProfile, true),
          //   userId: getStorage(StorageKey.userId),
          // }];
          this.$store.commit('setReserveInfo', destData);
          this.$router.push({
            name: routerMeta.meetingReserveFromRoom.name,
            params: {rid: this.rid},
          });
          return;
        }

        destData.meetingRooms = [{id: this.rid}];
        destData.insideParticipant = [getStorage(StorageKey.userId)];
        destData.numberOfPeople = 1;
        destData.enableNotice = this.sysNoticeInfo.enableNotice;
        destData.preNoticeTime = this.sysNoticeInfo.preNoticeTime;
        destData.endNoticeTime = this.sysNoticeInfo.endNoticeTime;

        UILoader.load("执行中...");
        meeting.reserveMeeting(this, {meeting: destData}).then(({newMeeting: res = {}}) => {
          if (checkRespCorrect(res, "保存失败")) {
            messageHdl({code: msgCode.SUCCESS});
            this.$router.push({
              name: routerMeta.meetingDetailFromRoom.name,
              params: {mid: res.insertId, rid: this.rid},
            })
          }
        }).catch(err => {
          messageHdl({msg: err.message});
        })
      },
    }
  }
</script>

<style lang="less">
  .pop-min-hgt {
    min-height: 80%;

    .van-cell {
      background-color: unset;
    }
  }

  .right-tag {
    border-radius: 999px 0 0 999px !important;
  }

  .custom-steps .van-steps--horizontal .van-steps__items {
    padding-right: 4px;
  }
</style>
